module.exports = __webpack_public_path__ + "img/bg-wallet-success-modal-dark.f3ce3932.webp";